export interface LEDMaterial {
  id: string;
  name: string;
  displayName: string;
  properties: {
    // NOTE: stored as RGB 0-255 for easier tweaking.
    // `Scene.ts` converts these to Babylon's 0-1 Color3.
    albedoColor: [number, number, number];
    metallic: number;
    roughness: number;
    environmentIntensity?: number;
    // NOTE: stored as RGB 0-255 for easier tweaking.
    // `Scene.ts` converts these to Babylon's 0-1 Color3.
    emissiveColor?: [number, number, number];
    emissiveIntensity?: number;
  };
}

export const LED_MATERIALS: LEDMaterial[] = [
  {
    id: 'led_red',
    name: 'led_red',
    displayName: 'White',
    properties: {
      // previously [0.1, 0.1, 0.1]
      albedoColor: [26, 26, 26],
      metallic: 0.0,
      roughness: 0.1,
      environmentIntensity: 0.3,
      emissiveColor: [225, 225, 225],
      emissiveIntensity: .3
    }
  },
  {
    id: 'led_blue',
    name: 'led_blue',
    displayName: 'Pink',
    properties: {
      // previously [0.1, 0.1, 0.1]
      albedoColor: [213, 1, 80],
      metallic: 0.0,
      roughness: 0.1,
      environmentIntensity: .3,
      emissiveColor: [253, 2, 20],
      emissiveIntensity: 1.4
    }
  },
  {
    id: 'led_green',
    name: 'led_green',
    displayName: 'Blue',
    properties: {
      // previously [0.1, 0.1, 0.1]
      albedoColor: [26, 26, 50],
      metallic: 0.0,
      roughness: 0.1,
      environmentIntensity: 0.3,
      // previously [0.0, 0.2, 1.0]
      emissiveColor: [0, 20, 255],
      emissiveIntensity: 2.0
    }
  },
  {
    id: 'led_white',
    name: 'led_white',
    displayName: 'Purple',
    properties: {
      // previously [0.1, 0.1, 0.1]
      albedoColor: [26, 26, 26],
      metallic: 0.0,
      roughness: 0.1,
      environmentIntensity: 0.3,
      emissiveColor: [33, 3, 220],
      emissiveIntensity: 4.0
    }
  }
]; 



